import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {Base, Shape} from 'diagram-js/lib/model';
import {
  generateEndGateWayToEndEventExpression,
  generateEndGateWayToUserInputExpression,
  scriptTaskName,
  scriptTaskResultVariablePostFix,
  startGatewayToScriptTaskConn,
  startGatewayToUserTaskConn,
  userTaskName
} from '@ispm/shared/bpmn-io/sub-process-consts';
import {
  endEvent,
  exclusiveGatewayType,
  scriptTaskType,
  startEvent,
  subProcessType,
  userTaskType
} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import {PathwaysModeling} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";

export class CreateSubprocessChildrenHandler implements CommandHandler {


  constructor(private modeling, private pathwaysModeling: PathwaysModeling, private elementFactory,
              private autoPlace, private bpmnReplace, private elementRegistry) {
  }

  execute(context): Base[] {
    return [context.element];
  }


  preExecute(context): any {
    // cache the element size,position, and connections positions
    const element = context.element;
    const position = {x: element.x, y: element.y};
    const size = {width: element.width, height: element.height};
    const updatedContext = {size, position};
    const outgoingConnection = element.outgoing[0];
    if (outgoingConnection) {
      const outgoingConnectionWayPoints = outgoingConnection.waypoints;
      Object.assign(updatedContext, outgoingConnectionWayPoints, outgoingConnection);
    }
    Object.assign(context, updatedContext);
    let incomingConnection, incomingConnectionWayPoints;
    if (element.incoming.length > 0) {
      incomingConnection = element.incoming[0];
      incomingConnectionWayPoints = incomingConnection.waypoints;
      Object.assign(context, {incomingConnection, incomingConnectionWayPoints});
    }
    if (ModelingUtil.getElementType(element) !== subProcessType) {
      const target = {type: subProcessType, isExpanded: false};
      context.element = this.bpmnReplace.replaceElement(element, target);
    }
  }

  postExecute(context): any {
    const sourceElement = context.element;
        if (sourceElement.children.length === 0) {
    this.buildSubProcessStructure(sourceElement);
    // reapply size, position, connection position/waypoints
    const bounds = Object.assign(context.size, context.position);
    this.modeling.resizeShape(sourceElement, bounds, bounds);
    if (context.outgoingConnection && context.outgoingConnectionWayPoints) {
      this.modeling.updateWaypoints(context.outgoingConnection, context.outgoingConnectionWayPoints);
    }
    if (sourceElement.incoming.length > 0) {
      this.modeling.updateWaypoints(context.incomingConnection, context.incomingConnectionWayPoints);
    }
        }
  }


  private buildSubProcessStructure(sourceElement: Shape) {
        const startEventElement = this.modeling.createShape({
        type: startEvent,
        id: `${startEvent}_${sourceElement.businessObject.id}`
      }, {x: sourceElement.x + 50, y: sourceElement.y + 50}, sourceElement, {});
    const userTaskShape = this.elementFactory.createShape({type: userTaskType}, {});

    const scriptTaskShape = this.elementFactory.createShape({type: scriptTaskType}, {});
    const startGateway = this.appendShapeToGateway(startEventElement);
    const scriptTask: Shape = this.autoPlace.append(startGateway, scriptTaskShape);
    this.setIncomingConnectionID(scriptTask, startGatewayToScriptTaskConn);
    const scriptTaskProperties = {
      name: scriptTaskName,
      scriptFormat: 'javascript',
      script: ''
    };
    scriptTaskProperties['camunda:resultVariable'] = `${sourceElement.id}_${scriptTaskResultVariablePostFix}`;
    this.modeling.updateProperties(scriptTask, scriptTaskProperties);
    const userTask = this.autoPlace.append(startGateway, userTaskShape);
    this.modeling.updateProperties(userTask, {name: userTaskName});
    this.setIncomingConnectionID(userTask, startGatewayToUserTaskConn);

    const endGateway: Shape = this.appendShapeToGateway(scriptTask);
    const endEventNode: Shape = this.elementFactory.createShape({type: endEvent}, {});
    this.autoPlace.append(endGateway, endEventNode);

    this.pathwaysModeling.appendConnectionExpression(endGateway.outgoing[0], generateEndGateWayToEndEventExpression(sourceElement.id));

    this.modeling.connect(userTask, endEventNode);
    this.modeling.connect(endGateway, userTask);
    this.pathwaysModeling.appendConnectionExpression(endGateway.outgoing[1], generateEndGateWayToUserInputExpression(sourceElement.id));

  }

  private appendShapeToGateway(sourceElement: Shape): Shape {
    const gatewayShape = this.elementFactory.createShape({type: exclusiveGatewayType}, {});
    return this.autoPlace.append(sourceElement, gatewayShape);
  }

  private setIncomingConnectionID(scriptTask: Shape, name: string) {
    const connection = scriptTask.incoming[0];
    this.modeling.updateProperties(connection, {id: `${scriptTask.id}_${name}`});
  }

}
